import React, { Fragment } from 'react';
import pluralize from 'pluralize';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  H4,
  Form,
  SectionDivider, ActionsWrapper, HighlightGroup,
  ProgressBar
} from '@contently/toolkit';

import AssignedStories from './assigned_stories';
import * as actions from '../../store/actions/index';

function statusData(data, status) {
  const { total, completed, failed, percent, fromUser, toUser } = data;

  const statusMapping = {
    waiting: {
      status: 'active',
      copy: 'Starting reassignment...',
      percent: 0
    },
    progress: {
      status: 'active',
      copy:
        `${completed} of ${pluralize('workflow step', total, true)} have been reassigned ` +
        `from ${fromUser} to ${toUser}` +
        ". It's ok to leave this page.",
      percent
    },
    success: {
      status: 'success',
      copy: `${pluralize('workflow step', total, true)} have been successfully reassigned.`,
      percent
    },
    error: {
      status: 'error',
      copy: `${pluralize('workflow step', failed, true)} must be addressed manually. ${pluralize('workflow step', completed, true)} have been reassigned.`,
      percent: percent > 0 ? percent : 100
    }
  };

  return statusMapping[status];
}

export const ReassignmentProgress = props => {
  const { reassignmentComplete, failed, total, setJobStatus, setJobId, setStories } = props;

  let status = '';

  if (!reassignmentComplete && !total) {
    status = 'waiting';
  } else if (!reassignmentComplete) {
    status = 'progress';
  } else if (failed > 0) {
    status = 'error';
  } else {
    status = 'success';
  }

  return (
    <Fragment>
      <HighlightGroup>
        <SectionDivider>
          <H4>{statusData(props, status).copy}</H4>
          <ProgressBar
            percent={statusData(props, status).percent}
            status={statusData(props, status).status}
          />
        </SectionDivider>
        {reassignmentComplete && (
          <ActionsWrapper>
            <Form.Button
              variant="primary"
              onClick={() => {
                setJobStatus(null);
                setJobId(null);
                setStories(null);
              }}
            >
              Reassign more
            </Form.Button>
          </ActionsWrapper>
        )}
      </HighlightGroup>
      <AssignedStories />
    </Fragment>
  );
};

ReassignmentProgress.propTypes = {
  reassignmentComplete: PropTypes.bool.isRequired,
  total: PropTypes.number,
  completed: PropTypes.number,
  percent: PropTypes.number,
  failed: PropTypes.number,
  setJobStatus: PropTypes.func.isRequired,
  setJobId: PropTypes.func.isRequired,
  setStories: PropTypes.func.isRequired
};

ReassignmentProgress.defaultProps = {
  total: 0,
  completed: 0,
  percent: 0,
  failed: 0
};

// Selectors

const getBrandProfileId = state => state.reassignUsers.brandProfileId;
const getPersistedState = state =>
  state.reassignUsers.persistedJobStatuses[getBrandProfileId(state)];
const getUser = (persistedJob, userRole) => (persistedJob ? persistedJob[userRole].label : null);

const mapStateToProps = state => ({
  reassignmentComplete: state.reassignUsers.currentJobStatus.isComplete,
  total: state.reassignUsers.currentJobStatus.total,
  completed: state.reassignUsers.currentJobStatus.completed,
  percent: state.reassignUsers.currentJobStatus.percentComplete,
  failed: state.reassignUsers.currentJobStatus.failures,
  fromUser: getUser(getPersistedState(state), 'fromUser'),
  toUser: getUser(getPersistedState(state), 'toUser')
});

const mapDispatchToProps = dispatch => ({
  setJobStatus: status => dispatch(actions.setJobStatus(status)),
  setJobId: id => dispatch(actions.setJobId(id)),
  setStories: stories => dispatch(actions.setStories(stories))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReassignmentProgress);



// WEBPACK FOOTER //
// ./app/javascript/app/components/reassign_users/reassignment_progress.jsx